import type { MouseEventHandler } from 'react';
import React, { forwardRef, useContext } from 'react';

import { Grid as AntGrid, Col } from 'antd';

import { MyTableContext } from '..';

interface IProps {
  screenSizes?: any;
  colSpan?: any;
  numeric?: boolean;
  mobileOrder?: number;
  status?: any;
  className?: any;
  style?: any;
  styles?: any;
  action?: any;
  responsive?: boolean;
  children?: React.ReactNode;
  onClick?: MouseEventHandler<HTMLTableDataCellElement>;
}

const DEFAULT_SCREEN_SIZES: any[] = [];

const MyTableCol = forwardRef<any, IProps>(
  (
    {
      screenSizes = DEFAULT_SCREEN_SIZES,
      colSpan,
      numeric,
      mobileOrder,
      status,
      className,
      style,
      styles: customStyles,
      action,
      children,
      onClick
    },
    ref
  ) => {
    const { responsive } = useContext(MyTableContext);
    const screens = AntGrid.useBreakpoint();
    const isDesktop = !!screens.md;

    const isHiddenAtCurrentBreakpoint = (): boolean => {
      if (!screens.sm) return screenSizes['xs'] === 0;
      if (!screens.md) return screenSizes['sm'] === 0;
      if (!screens.lg) return screenSizes['md'] === 0;
      return screenSizes['lg'] === 0;
    };

    if (!responsive || isDesktop) {
      return (
        <td
          ref={ref}
          colSpan={colSpan}
          className={`relative min-h-[96px] bg-gray-100 px-2 py-2 text-[13px] leading-[1.3] first:pl-4 last:pr-4 ${numeric ? 'text-right' : ''} ${
            status ? 'status' : ''
          } ${className || ''}`}
          style={style}
          onClick={onClick}
        >
          {children}
        </td>
      );
    }

    if (isHiddenAtCurrentBreakpoint()) {
      return null;
    }

    return (
      <Col
        ref={ref}
        style={{ order: mobileOrder ? mobileOrder : 'initial', ...customStyles }}
        className={`relative bg-gray-100 p-4 text-[13px] leading-[1.3] max-sm:flex max-sm:items-center ${numeric ? 'text-right' : ''} ${
          action ? 'max-sm:justify-center' : ''
        } ${status ? 'status' : ''} ${className || ''}`}
        xs={(screenSizes['xs'] || 0) * 2}
        sm={(screenSizes['sm'] || 0) * 2}
        md={(screenSizes['md'] || 0) * 2}
        lg={(screenSizes['lg'] || 0) * 2}
        onClick={onClick as any}
      >
        {children}
      </Col>
    );
  }
);

export default MyTableCol;
